module.exports = __webpack_public_path__ + "static/media/5Specialties.450b3639.svg";